<template>
  <div>
    <!--Indicadores recomendados para o Programa selecionado-->
    <div v-if="opcoes && opcoes.length" class="row" style="margin-left:0; margin-right:0;">
      <div v-for="(opcao, idx) in opcoes" :key="'op-' + idx" class="col-md-6" style="padding:4px 15px;">
        <label class="new-control new-control-checkbox" style="padding-top:4px; font-weight:normal; cursor:pointer;">
          <input type="checkbox" :disabled="disabled" :checked="estaSelecionado(opcao)" @change="alterna(opcao)">
          &nbsp;{{ opcao }}
          <div class="new-control-indicator"></div>
        </label>
      </div>
    </div>
    <div v-else class="mensagem" style="color:#a8a8a8; font-weight:normal; font-size:14px; padding:4px 0;">
      Selecione um Programa para ver os indicadores recomendados, ou adicione indicadores abaixo.
    </div>

    <!--Indicadores adicionais (livres ou herdados de outro Programa) — permanecem visíveis mesmo quando desmarcados-->
    <div v-if="extrasVisiveis.length" class="row" style="margin-left:0; margin-right:0; margin-top:6px;">
      <div v-for="(item, idx) in extrasVisiveis" :key="'ex-' + idx" class="col-md-6" style="padding:4px 15px;">
        <label class="new-control new-control-checkbox" style="padding-top:4px; font-weight:normal; cursor:pointer;">
          <input type="checkbox" :disabled="disabled" :checked="estaSelecionado(item.descricao)" @change="alterna(item.descricao, item.custom)">
          &nbsp;{{ item.descricao }}
          <span v-if="item.custom" style="color:#a8a8a8;">&nbsp;(livre)</span>
          <div class="new-control-indicator"></div>
        </label>
      </div>
    </div>

    <!--Adicionar indicador livre-->
    <div v-if="!disabled" class="row" style="margin-left:0; margin-right:0; margin-top:8px; align-items:flex-end;">
      <div class="form-group col-md-6" style="margin-bottom:0;">
        <input v-model="novoIndicador" type="text" class="form-control" maxlength="255"
               placeholder="Adicionar indicador não listado" @keyup.enter.prevent="adiciona">
      </div>
      <div class="col-md-3" style="padding-top:2px;">
        <button type="button" @click="adiciona" class="btn btn-default btn-sm btn-flat" :disabled="!novoIndicador">
          <i class="fa fa-plus"></i> Adicionar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'checklist-indicadores',
    props: {
      // Lista de indicadores recomendados (strings) para o Programa selecionado
      opcoes: {
        type: Array,
        default: () => []
      },
      // v-model: array de { descricao, custom } — contém apenas os SELECIONADOS
      value: {
        type: Array,
        default: () => []
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        novoIndicador: '',
        // Indicadores adicionais conhecidos (livres ou de outro Programa). Persistem
        // como checkbox mesmo quando desmarcados, para poderem ser remarcados.
        extras: []
      }
    },
    computed: {
      // Extras que não fazem parte das opções do Programa atual (as demais já
      // aparecem na lista de recomendados)
      extrasVisiveis () {
        return this.extras.filter(item => !this.opcoes.includes(item.descricao))
      }
    },
    watch: {
      value: {
        handler: 'sincronizaExtras',
        immediate: true
      },
      opcoes: 'sincronizaExtras'
    },
    methods: {
      // Garante que todo selecionado fora das opções do Programa exista em `extras`,
      // sem nunca removê-lo (para não sumir ao desmarcar).
      sincronizaExtras () {
        (this.value || []).forEach(item => {
          if (!this.opcoes.includes(item.descricao) && !this.extras.some(e => e.descricao === item.descricao)) {
            this.extras.push({ descricao: item.descricao, custom: !!item.custom })
          }
        })
      },
      estaSelecionado (descricao) {
        return (this.value || []).some(item => item.descricao === descricao)
      },
      alterna (descricao, custom = null) {
        let atual = this.value || []
        if (this.estaSelecionado(descricao)) {
          this.$emit('input', atual.filter(item => item.descricao !== descricao))
        } else {
          let ehCustom = custom !== null ? custom : !this.opcoes.includes(descricao)
          this.$emit('input', [...atual, { descricao: descricao, custom: ehCustom }])
        }
      },
      adiciona () {
        let descricao = (this.novoIndicador || '').trim()
        if (!descricao) {
          return
        }
        let custom = !this.opcoes.includes(descricao)
        // Mantém o indicador livre visível como checkbox, mesmo se depois desmarcado
        if (custom && !this.extras.some(e => e.descricao === descricao)) {
          this.extras.push({ descricao: descricao, custom: true })
        }
        if (!this.estaSelecionado(descricao)) {
          this.$emit('input', [...(this.value || []), { descricao: descricao, custom: custom }])
        }
        this.novoIndicador = ''
      }
    }
  }
</script>



// WEBPACK FOOTER //
// checklistIndicadores.vue?e5ed6698